import { useLanguage } from "../LanguageContext";

export default function LoadingSpinner({ message }) {
  const { t } = useLanguage();
  return (
    <div className="flex flex-col items-center justify-center py-16 gap-4">
      <div className="relative w-16 h-16">
        <div className="absolute inset-0 rounded-full border-4 border-amber-100" />
        <div className="absolute inset-0 rounded-full border-4 border-amber-600 border-t-transparent animate-spin" />
      </div>
      <div className="text-center">
        <p className="text-sm font-medium text-stone-700">{message}</p>
        <p className="text-xs text-stone-400 mt-1">{t.spinner.subtext}</p>
      </div>
    </div>
  );
}
